import { getArticlesByMediaId } from "@coworker/app/src/components/RoomSettings/services/medias.service";
import { deleteArticleByIds } from "@coworker/app/src/components/RoomSettings/services/articles.service";
import { getByPath } from "../../shared/helpers/object.helper";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";

type RemoveMediaArticlesProps = {
  reason: string;
  items: string;
  mediaId: string;
};

export const removeMediaArticlesAfterComplete = async (
  task: Record<string, unknown>,
  props: RemoveMediaArticlesProps
): Promise<void> => {
  const { reason, items, mediaId } = props;
  const taskItems = getByPath(task, items) as ItemNoAndType[] | null;
  const taskReason = getByPath(task, reason) as string | null;
  const taskMediaId = getByPath(task, mediaId) as string | null;

  if (taskReason === "remove" && taskItems && taskMediaId) {
    const articlesForMedia = await getArticlesByMediaId(taskMediaId);
    const articlesToDelete = articlesForMedia.filter((article) =>
      taskItems.some((item) => item.no === article.productArticleId)
    );
    await deleteArticleByIds(articlesToDelete.map((article) => article.id));
  }
};
